/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export let Pricing;
(function (_Pricing) {
  let LoanEstimateSectionTypes = /*#__PURE__*/function (LoanEstimateSectionTypes) {
    LoanEstimateSectionTypes["Escrow"] = "G";
    LoanEstimateSectionTypes["LenderCredits"] = "LenderCredits";
    LoanEstimateSectionTypes["OriginationCharges"] = "A";
    LoanEstimateSectionTypes["Other"] = "H";
    LoanEstimateSectionTypes["Payoffs"] = "Payoffs";
    LoanEstimateSectionTypes["Prepaids"] = "F";
    LoanEstimateSectionTypes["ServicesNotShopped"] = "B";
    LoanEstimateSectionTypes["ServicesShopped"] = "C";
    LoanEstimateSectionTypes["Taxes"] = "E";
    return LoanEstimateSectionTypes;
  }({});
  _Pricing.LoanEstimateSectionTypes = LoanEstimateSectionTypes;
  let FeeStatus = /*#__PURE__*/function (FeeStatus) {
    FeeStatus["APPROVED"] = "APPROVED";
    FeeStatus["IN_PROGRESS"] = "IN_PROGRESS";
    return FeeStatus;
  }({});
  _Pricing.FeeStatus = FeeStatus;
  let UpdateType = /*#__PURE__*/function (UpdateType) {
    UpdateType["ADD"] = "ADD";
    UpdateType["DELETE"] = "DELETE";
    UpdateType["EDIT"] = "EDIT";
    return UpdateType;
  }({});
  _Pricing.UpdateType = UpdateType;
  let FeeSystem = /*#__PURE__*/function (FeeSystem) {
    FeeSystem["BLEND_TITLE_WORKSPACE"] = "BLEND_TITLE_WORKSPACE";
    FeeSystem["LOS"] = "LOS";
    return FeeSystem;
  }({});
  _Pricing.FeeSystem = FeeSystem;
})(Pricing || (Pricing = {}));